export var localeSelector = function () { return function (state) {
    return state.locale;
}; };
//# sourceMappingURL=locale.js.map